import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../styles/saas.css";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const target = token ? `/signup?token=${encodeURIComponent(token)}` : "/signup";

  return (
    <div className="saas-page saas-auth">
      <h1>Verify your email</h1>
      <p>Enter the code from your email on the signup page.</p>
      <Link to={target} className="saas-btn saas-btn--primary">Continue verification</Link>
    </div>
  );
}
